import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

interface Props {
  allowedLevels: string[];
}

const ProtectedRoute = ({ allowedLevels }: Props) => {
  const token = useSelector((state: RootState) => state.auth.token);
  const nivel = useSelector((state: RootState) => state.auth.user?.nivel);

  if (!token) {
    return <Navigate to="/area-do-cliente" replace />;
  }

  if (!allowedLevels.includes(nivel as string)) {
  return <Navigate to="/nao-autorizado" replace />;
}

  return <Outlet />;
};

export default ProtectedRoute;
